import React from "react";

export default function EditPatientDoctorModal({ show, onClose, selectedPatientForEdit, editDoctorForm, setEditDoctorForm, onSubmit, doctors }) {
  if (!show || !selectedPatientForEdit) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Edit Doctor - {selectedPatientForEdit.name}</h2>
        <form onSubmit={onSubmit}>
          <div className="admin-row">
            <label>Current Doctor</label>
            <input
              type="text"
              value={selectedPatientForEdit.doctor_name || "Unassigned"}
              disabled
              style={{ background: '#f3f4f6', color: '#6b7280' }}
            />
          </div>
          <div className="admin-row">
            <label>Assign to Doctor *</label>
            <select
              required
              value={editDoctorForm.doctor_id}
              onChange={(e) => setEditDoctorForm({...editDoctorForm, doctor_id: e.target.value})}
            >
              <option value="">Select Doctor</option>
              {doctors.map(d => (
                <option key={d.user_id} value={d.user_id}>
                  {d.display_name || d.user_name} {d.role_specialization ? `(${d.role_specialization})` : ''}
                </option>
              ))}
            </select>
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
            <button type="submit" className="btn btn-primary">Update Doctor</button>
            <button
              type="button"
              className="btn"
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
